<template>
    <div class="container" v-bind:class="{'container-data' : !isEmpty(metric)}">
      <div class="row">
        <div v-bind:class="{'col-12' : isEmpty(metric.removed), 'col-6' : !isEmpty(metric.removed)}" class="card align-self-start" v-if="metric.added !== undefined"> <!-- style="border: 5px solid yellow;" -->
          <div class="card-body">
            <h3 class="card-title">Added | {{graphProperties.date | monent('DD-MM-YYYY hh:mm:ss')}}</h3>
            <table class="table">
              <thead>
                <th scope="col">Service</th>
                <th scope="col">Total Added</th>
              </thead>
              <tbody>
                <tr v-for="(index, instance) in metric.added" :key="`${metric.count}` + `${index}` + Math.random()">
                  <td>{{instance}}</td>
                  <td>{{metric.added[instance]}}</td>
                </tr>
              </tbody>
            </table>
            <!-- <div class="card-text" v-for="(index, instance) in metric.added" :key="`${metric.count}` + `${index}` + Math.random()" >{{instance}}, {{metric.added[instance]}}</div> -->
          </div>
        </div>
        <div v-else></div>
        <div class="card col-6 align-self-start" v-if="!isEmpty(metric.removed)"> <!-- style="border: 5px solid yellow;" -->
          <div class="card-body">
            <h3 class="card-title">Removed | {{graphProperties.date | moment('DD-MM-YYYY hh:mm:ss')}}</h3>
            <table class="table">
              <thead>
                <th scope="col">Service</th>
                <th scope="col">Total Removed</th>
              </thead>
              <tbody>
                <tr v-for="(index, instance) in metric.removed" :key="`${metric.count}` + `${index}` + Math.random()">
                  <td>{{instance}}</td>
                  <td>{{metric.removed[instance]}}</td>
                </tr>
              </tbody>
            </table>
            <!-- <div class="card-text" v-for="(index, instance) in metric.removed" :key="`${metric.count}` + `${index}` + Math.random()">{{instance}}, {{metric.removed[instance]}}</div> -->
          </div>
        </div>
        <div v-else></div>
      </div>
    </div>
</template>

<script>
export default {
  name: 'MetricData',
  props: [
    'graphProperties',
    'metric'
  ],
  methods: {
    isEmpty: function (obj) {
      if (obj === null || obj === undefined) {
        return true
      } else if (Object.keys(obj).length === 0) {
        return true
      } else {
        return false
      }
    }
  }
}
</script>

<style scoped>
.row {
    overflow: hidden;
}

.card {
  border: 0;
}

.container-data {
  border: 1px solid rgba(0,0,0,.125)
}
</style>



// WEBPACK FOOTER //
// src/components/Deployment/MetricData.vue